import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/AnimatedBlock.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/AnimatedText.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/ParallaxImage.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/ServiceList.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
